import { define } from 'wicked-elements'
import loadGoogleMapsAPI from 'load-google-maps-api'

window.googleInstance = null

// Quick hack to store the embed globally to 
// recycle avoiding multiple webgl context bugs
var embed = null
var $streetView = document.createElement('div')
$streetView.classList.add('w-full', 'h-full')

define('[data-component~="street-view"]', {
  init () {
    this.options = {
      position: {
        lat: parseFloat(this.element.dataset.lat || 0), 
        lng: parseFloat(this.element.dataset.lng || 0)
      },
      pov: {
        heading: parseFloat(this.element.dataset.heading || 0), 
        pitch: parseFloat(this.element.dataset.pitch || 0)
      }
    }
  },
  connected () {
    if (!window.googleInstance) {
      loadGoogleMapsAPI({
        key: 'AIzaSyBmmlBhuvBCnIqX30djI_dTmtw_tF-z8OY'
      }).then(function (google) {
        window.googleInstance = google
        this.initMapEmbed()
      }.bind(this)).catch((err) => {})
    } else {
      this.initMapEmbed()
    }
  },
  disconnected () {
    
  },
  initMapEmbed () {
    if (embed) {
      embed.setVisible(false)
      embed.setPosition(this.options.position)
      embed.setPov(this.options.pov)
      embed.setZoom(0)
      setTimeout(() => {
        embed.setVisible(true)
      }, 650)
    } else {
      embed = new window.googleInstance.StreetViewPanorama($streetView, {
        position: this.options.position,
        pov: this.options.pov,
        panControl: false,
        addressControl: false,
        zoomControl: false,
        linksControl: true,
        fullscreenControl: false
      })
    }

    // Append recycled dom element
    this.element.appendChild($streetView)
  }
})